import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IPublishedConnectionDescriptionParams {
  id: string;
  description: string;
}

export class SetPublishedConnectionDescriptionRequest extends Request<IPublishedConnectionDescriptionParams, IResult> {
  constructor(params: IPublishedConnectionDescriptionParams) {
    super('setPublishedConnectionDescription', params);
  }
}
